import type { Term } from "../types";
import { AdminTermsTable } from "../components/AdminTermsTable";

export interface AdminContributionsPageProps {
  /** Non–staff-Word-Master submissions only. */
  contributionTerms: Term[];
  isLoading: boolean;
  onEdit: (term: Term) => void;
  onDelete: (term: Term) => void;
  canDeleteTerms: boolean;
  onStatusChange: (
    term: Term,
    next: "pending" | "approved" | "rejected"
  ) => void;
  onRefresh: () => void;
  onTermUpdated?: (term: Term) => void;
}

export function AdminContributionsPage({
  contributionTerms,
  isLoading,
  onEdit,
  onDelete,
  canDeleteTerms,
  onStatusChange,
  onRefresh,
  onTermUpdated,
}: AdminContributionsPageProps) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="mb-1 font-serif text-2xl font-bold">
          All Contributions
        </h2>
        
      </div>
      <AdminTermsTable
        terms={contributionTerms}
        status="all"
        isLoading={isLoading}
        showDeleteActions={canDeleteTerms}
        onEdit={onEdit}
        onDelete={onDelete}
        onStatusChange={onStatusChange}
        onRefresh={onRefresh}
        onTermUpdated={onTermUpdated}
      />
    </div>
  );
}
